import { render, staticRenderFns } from "./OrderTagKeysDetails.vue?vue&type=template&id=264cb395&"
import script from "./OrderTagKeysDetails.vue?vue&type=script&lang=js&"
export * from "./OrderTagKeysDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports